import * as React from 'react';
import PropTypes from 'prop-types';
import { Card, StampCard, Button, Icon } from 'tabler-react';
import modal from '../../components/Modal';
import Withdrowal from './Withdrowal';
import Table from './Table';

class AffiliateOverview extends React.Component {
  withdraw = () => {
    const { affWithdrawAccount, refreshAmount } = this.props;
    modal(
      <Withdrowal
        affWithdrawAccount={affWithdrawAccount}
        refreshAmount={refreshAmount}
      />,
      {
        title: '每月自动提现设置',
      },
    );
  };

  Records = initialTab => {
    modal(
      <Table
        withdrawList={this.props.withdrawList}
        bonuses={this.props.bonuses}
        initialTab={initialTab}
      />,
    );
  };

  render() {
    const { balance, affid, recent } = this.props;

    return (
      <Card>
        <Card.Header className="overview">
          <Card.Title> 账户总览 </Card.Title>
          <div className="tab1 tab" onClick={() => this.Records('提现记录')}>
            <Icon name="file-minus" /> 提现记录
          </div>
          <div className="tab2 tab" onClick={() => this.Records('推荐记录')}>
            <Icon name="file-plus" /> 推荐记录
          </div>
        </Card.Header>
        <Card.Body className="affiliate-overview">
          <StampCard
            color="red"
            icon="credit-card"
            header={recent || '0.00'}
            footer="结算中(美元)"
          />
          <StampCard
            color="success"
            icon="credit-card"
            header={balance || '0.00'}
            footer="可提现(美元)"
          />
          <Button
            className="affiliate-show-withdrowal-btn"
            outline
            color="primary"
            onClick={this.withdraw}
            disabled={!affid}>
            提现设置
          </Button>
        </Card.Body>
      </Card>
    );
  }
}

AffiliateOverview.propTypes = {
  balance: PropTypes.number,
  recent: PropTypes.number,
  affid: PropTypes.string,
  refreshAmount: PropTypes.func,
  bonuses: PropTypes.array,
  withdrawList: PropTypes.array,
  affWithdrawAccount: PropTypes.object,
};

export default AffiliateOverview;
